import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaShippingFast } from "react-icons/fa";
import { FaArrowUp } from "react-icons/fa";
import { FaUsersRays } from "react-icons/fa6";
import { MdOutlineShoppingBag } from "react-icons/md";
import * as api from "../../api/index";
import { jwtDecode } from "jwt-decode";
import AOS from "aos";
import "aos/dist/aos.css";
import SellerCard from "./Sellercard";

const Home = () => {
  const navigate = useNavigate();
  let decoded = null;
  const token = localStorage.getItem("token");
  const [showPopup, setShowPopup] = useState(false);
  const [rotatedText, setRotatedText] = useState("Anything");
  const words = ["Anything", "Everything", "ASAP⚡"];
  const [sellers, setSellers] = useState([]);
const [loadingSellers, setLoadingSellers] = useState(true);
const [page, setPage] = useState(1);
const [hasMore, setHasMore] = useState(true);

  const phoneNumber = "2349026235719";
  const message = encodeURIComponent("Hello,");

  const fetchHomepageSellers = async (pageNumber = 1, append = false) => {
  try {
    if (!append) setLoadingSellers(true);

    const { data } = await api.GetHomepageSellers(pageNumber);

    if (data.success) {
      if (append) {
        setSellers(prev => [...prev, ...data.sellers]);
      } else {
        setSellers(data.sellers);
      }

      setHasMore(data.hasMore);
    }
  } catch (err) {
    console.log(err);
  } finally {
    setLoadingSellers(false);
  }
};
const handleSeeMore = () => {
    const nextPage = page + 1;

    setPage(nextPage);

    fetchHomepageSellers(nextPage, true);
};
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
useEffect(() => {
    fetchHomepageSellers();
}, []);

  // Social Links mapping
  const socialLinks = {
    Tiktok: "https://vm.tiktok.com/ZSHEdmQenUT4D-84lJU/",
   
    WhatsApp: `https://wa.me/${phoneNumber}?text=${message}`,
    X: "https://x.com/Ourasap_Market",
  };

  const handleWhatsAppClick = () => {
    window.open(socialLinks.WhatsApp, '_blank');
  };

   const handleContractClick = () => {
    navigate("/create-contract");
  };

  const handleFindSeller = () => navigate("/select");
  const handleFindProducts = () => navigate("/select-product");

  useEffect(() => {
    const lastShown = localStorage.getItem("popup_last_shown");
    const now = Date.now();
    if (!lastShown || now - lastShown > 12 * 60 * 60 * 1000) {
      setShowPopup(true);
      localStorage.setItem("popup_last_shown", now);
    }
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1500 });
    let i = 0;
    const interval = setInterval(() => {
      i = (i + 1) % words.length;
      setRotatedText(words[i]);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  if (token && typeof token === "string" && token.length > 0) {
    try {
      decoded = jwtDecode(token);
    } catch (err) {
      localStorage.removeItem("token");
      decoded = null;
    }
  }

  const userId = decoded?.id || decoded?._id || null;

  return (
    <>
      {/* POPUP AD - Styled to match Dark Theme */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-[9999] p-4">
          <div className="bg-[#111827] border border-white/10 rounded-3xl shadow-2xl w-[400px] max-h-[80vh] p-8 relative overflow-y-auto transform scale-100 animate-scaleIn">
            <button onClick={() => setShowPopup(false)} className="absolute top-5 right-5 text-gray-500 hover:text-white transition">✕</button>
            <h2 className="text-2xl font-black text-center mb-2 text-orange-500">OurASAP Features</h2>
            <p className="text-sm hidden text-center text-gray-400 mb-6 font-bold">Buy, Sell and Deliver <span className="text-orange-500">{rotatedText}</span></p>
            <div className="mb-6 p-4 bg-orange-500/10 border border-orange-500/20 rounded-2xl text-center">
              <h3 className="text-orange-500 font-black text-sm uppercase mb-1">Everyone Can Sell!</h3>
              <p className="text-[11px] text-gray-300 leading-relaxed">
                Whether you are <span className="text-white font-bold">Sellers</span> looking to sell items or <span className="text-white font-bold">Buyers</span> looking for specific products or seller, you can sell on OurASAP.
              </p>
            </div>
            <div className="space-y-6 text-gray-300 text-xs">
              <div>
                <h3 className="font-bold text-orange-500 mb-2 uppercase tracking-wider flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-orange-500 rounded-full"></span> For Buyers
                </h3>
                <ul className="space-y-1.5 opacity-80 list-disc list-inside">
                  <li className="text-white font-semibold">Send "Errands" for items you need</li>
                  <li>Refundable products & Secure payments</li>
                  <li>Direct negotiation with sellers</li>
                  <li>100% product insurance via OurASAP</li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-orange-500 mb-2 uppercase tracking-wider flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-orange-500 rounded-full"></span> For Sellers
                </h3>
                <ul className="space-y-1.5 opacity-80 list-disc list-inside">
                  <li className="text-white font-semibold">Post unlimited items for sale</li>
                  <li>No ad fees & Instant visibility</li>
                  
                  <li>Secure agent-based product collection</li>
                </ul>
              </div>
            </div>
            <button onClick={() => setShowPopup(false)} className="mt-8 w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-xl shadow-lg shadow-orange-500/20 transition active:scale-95">
              Start Posting Now
            </button>
          </div>
        </div>
      )}

      <div className="h-fit w-full relative bg-[#0B0F19] overflow-x-hidden">
        
        {/* Hero Section */}
        <section className="h-screen relative bg-[#0B0F19] overflow-hidden flex items-center justify-center">
          <div className="absolute inset-0 opacity-40">
            <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-orange-600 rounded-full blur-[120px]"></div>
            <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-blue-700 rounded-full blur-[120px]"></div>
          </div>
          <div className="text-center px-6 text-white relative z-10 max-w-4xl w-full">
            <h1 className="text-4xl md:text-7xl font-black leading-[1.1] text-white tracking-tight mb-8">
              Buy, Sell and Deliver{' '}
              <span key={rotatedText} className={`inline-block animate-fade-in-up ${rotatedText === "ASAP⚡" ? "text-orange-500" : "text-white"}`}>
                {rotatedText}
              </span>
            </h1>
            {/* <p className="text-gray-400 font-medium mb-10 text-base md:text-xl max-w-2xl mx-auto leading-relaxed">
              Connect with quality sellers and verified products in your neighborhood. Fast, secure, and reliable.
            </p> */}
            <div className="flex  sm:flex-row items-center justify-center gap-4">
              <button onClick={handleFindSeller} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold px-10 py-4 rounded-2xl shadow-xl shadow-orange-500/20 transition-all active:scale-95">
                Find Sellers
              </button>
              <button onClick={handleFindProducts} className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white backdrop-blur-md border border-white/20 font-bold px-10 py-4 rounded-2xl transition-all active:scale-95">
                Find Products
              </button>
            </div>
            <div className="mt-10">
               <button
    onClick={handleWhatsAppClick}
    className="group flex items-center gap-3 text-emerald-400 font-bold hover:text-emerald-300 transition-all mx-auto active:scale-95"
  >
    <span className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center group-hover:bg-emerald-500/20 transition-all">
      <span className="text-xl">💬</span>
    </span>

    Chat on WhatsApp
  </button>
            </div>
          </div>
        </section>
<section className="max-w-7xl mx-auto px-4 py-14">

    <div className="flex justify-between items-center mb-8">

        <h2 className="text-3xl font-bold text-center text-white">
            Featured Sellers
        </h2>

    </div>

    <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">

        {sellers.map((biz)=>(

            <SellerCard
                key={biz._id}
                biz={biz}
            />

        ))}

    </div>

{hasMore && (
  <div className="flex justify-center items-center gap-3 mt-10">

    <button
      onClick={handleSeeMore}
      className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-xl font-bold"
    >
      See More
    </button>

    <button
      onClick={scrollToTop}
      className="w-12 h-12 rounded-xl bg-gray-900 hover:bg-black text-white flex items-center justify-center transition"
      title="Back to top"
    >
      <FaArrowUp />
    </button>

  </div>
)}

</section>
  {/* NEW SECTION: Stats & Explore Button */}
{/* <section className="py-12 bg-[#0B0F19] border-y border-white/5">
  <div className="max-w-6xl mx-auto px-6 flex flex-col  items-center justify-center gap-8">
    
    <div data-aos="fade-right" className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
      
      
      <div className="flex -space-x-3 transition-hover duration-300">
        {[
          "https://res.cloudinary.com/dvuq6vmiy/image/upload/v1768349366/blob_jrn0hLtgw_x6pxmt.webp",
          "https://res.cloudinary.com/dvuq6vmiy/image/upload/v1768349312/blob_H7nldkFo3d_yeckbl.webp",
      "https://images.unsplash.com/photo-1723221907187-3e88c1d74b99?q=80&w=1287&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          "https://res.cloudinary.com/dvuq6vmiy/image/upload/v1768349877/IMG_6629_zrvr25.jpg"
        ].map((src, index) => (
          <div 
            key={index}
            className="relative w-12 h-12 rounded-full border-2 border-[#0B0F19] bg-gray-800 overflow-hidden shrink-0"
          >
            <img 
              src={src} 
              alt={`Vendor partner ${index + 1}`} 
              className="w-full h-full object-cover" 
              loading="lazy"
            />
          </div>
        ))}
      </div>

      <div>
        <h4 className="text-white font-black text-2xl tracking-tight">1,000+ Sellers</h4>
        <p className="text-gray-400 text-sm">Trusted vendors ready to serve you</p>
      </div>
    </div>
    
    <div data-aos="fade-left" className="w-auto">
      <button 
        onClick={handleFindSeller} 
        aria-label="Explore Marketplace"
        className="group w-auto flex items-center justify-center gap-3 bg-white/5 hover:bg-orange-500 border border-white/10 hover:border-orange-500 px-8 py-4 rounded-2xl text-white font-bold transition-all duration-300 shadow-lg hover:shadow-orange-500/20"
      >
        <span>Explore Marketplace</span>
        <span className="group-hover:translate-x-1 transition-transform duration-300" aria-hidden="true">→</span>
      </button>
    </div>
  </div>
</section> */}

        {/* How It Works */}
        {/* <section className="py-20 bg-[#0B0F19] px-6">
          <h2 className="text-center font-bold text-white text-3xl mb-12">How It Works</h2>
          <div className="grid md:grid-cols-1 grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              { step: "1", title: "Choose What You Want", desc: "Browse items, select products, or describe your delivery. We handle the details.", scale : "fade-right" },
              { step: "2", title: "Find Sellers", desc: "We link you with nearby sellers or OurASAP agents for faster, smoother service.", scale : "fade-up" },
              { step: "3", title: "Delivered to You", desc: "Your order arrives quickly and securely right at your doorstep.", scale : "fade-left" },
            ].map((item, i) => (
              <div data-aos={item.scale} key={i} className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-3xl p-8 text-center hover:bg-white/10 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto bg-orange-500 text-white rounded-2xl mb-6 shadow-lg shadow-orange-500/20">
                  <span className="text-2xl font-black">{item.step}</span>
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">{item.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section> */}

        {/* Activities */}
        {/* <section className="w-full h-fit text-white py-10 px-4">
          <h2 className="text-center text-white capitalize pb-16 font-bold text-3xl">List of Activities</h2>
          <div className="flex md:flex-col flex-row max-w-7xl mx-auto overflow-hidden rounded-[2.5rem] border border-white/5 shadow-2xl">
            <div className="md:w-full w-1/2 p-12 h-auto bg-gradient-to-br from-orange-500 to-orange-600 flex flex-col justify-center">
              <h2 data-aos="fade-right" className="capitalize text-white font-black text-3xl md:text-4xl leading-tight">
                Beyond delivery, we simplify your life.
              </h2>
              <ul data-aos="fade-right" className="list-none mt-8 text-white font-medium space-y-4">
                {[
                  "Personalized errand services",
                  "Connect with nearby sellers instantly",
                  "Fast and reliable delivery across locations",
                  "AI-powered fair visibility for every seller",
                  "Real-time package tracking",
                  "Custom orders handled with ease"
                ].map((text, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <span className="w-5 h-5 bg-white/20 rounded-full flex items-center justify-center text-[10px]">✓</span> 
                    {text}
                  </li>
                ))}
              </ul>
            </div>
            <div data-aos="fade-left" className="md:hidden block w-1/2 overflow-hidden">
              <img src="https://res.cloudinary.com/dvuq6vmiy/image/upload/v1753663469/blog2_package_img_xixbjh.webp" alt="Activities" className="w-full h-full object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-700" />
            </div>
          </div>
        </section> */}

        {/* Testimonials */}
        {/* <section className="py-20 bg-[#0B0F19] px-6">
          <h2 className="text-center font-bold text-white text-3xl mb-12">What Our Users Say</h2>
          <div className="grid md:grid-cols-1 grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              { name: "Tosin", city: "Ikoyi", img: "https://res.cloudinary.com/dvuq6vmiy/image/upload/v1764764619/smart-araromi-OsF-yoSf9ww-unsplash_veltyn.jpg", text: "I love how easy it is to connect with sellers and track everything in real-time.", scale: "fade-right" },
              { name: "Dami", city: "Manchester", img: "https://res.cloudinary.com/dvuq6vmiy/image/upload/v1758622573/791ed5d4-f2aa-4066-9099-047030573532_m7w49h.jpg", text: "Instead of wasting hours on logistics, I just make a request — they handle the rest!", scale: "fade-up" },
              { name: "Ngozi", city: "Yaba", img: "https://res.cloudinary.com/dvuq6vmiy/image/upload/v1764764259/francis-odeyemi-qZdvXE0pvIU-unsplash_dovtiw.jpg", text: "Professional and trustworthy service. The live updates are amazing.", scale: "fade-left" },
            ].map((item, i) => (
              <div data-aos={item.scale} key={i} className="bg-white/5 border border-white/5 p-8 rounded-[2rem] hover:border-orange-500/30 transition-all">
                <div className="flex items-center mb-6">
                  <img src={item.img} alt="User" className="w-14 h-14 rounded-full object-cover mr-4 ring-2 ring-orange-500/20" />
                  <div>
                    <h3 className="font-bold text-white">{item.name}</h3>
                    <p className="text-xs text-orange-400 font-bold tracking-widest">{item.city}</p>
                  </div>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed italic">"{item.text}"</p>
              </div>
            ))}
          </div>
        </section> */}

        {/* Features */}
        {/* <section className="py-20 px-6 bg-[#0B0F19]">
          <h2 className="text-center font-bold text-white text-3xl mb-12">Why Choose Us?</h2>
          <div className="grid md:grid-cols-1 grid-cols-3 gap-10 max-w-6xl mx-auto">
            <div data-aos="fade-right" className="p-10 bg-white/5 rounded-3xl text-center border border-white/5 hover:border-orange-500/50 transition-all">
              <FaUsersRays className="text-5xl text-orange-500 mb-6 mx-auto" />
              <h3 className="text-xl font-bold text-white mb-3">Fair Visibility</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Every seller gets equal exposure — no ads, no pay-to-win. Refresh rotates sellers to ensure fairness.</p>
            </div>
            <div data-aos="fade-up" className="p-10 bg-white/5 rounded-3xl text-center border border-white/5 hover:border-orange-500/50 transition-all">
              <MdOutlineShoppingBag className="text-5xl text-orange-500 mb-6 mx-auto" />
              <h3 className="text-xl font-bold text-white mb-3">End-to-End</h3>
              <p className="text-gray-400 text-sm leading-relaxed">From finding sellers to doorstep delivery — our system handles everything so you can focus.</p>
            </div>
            <div data-aos="fade-left" className="p-10 bg-white/5 rounded-3xl text-center border border-white/5 hover:border-orange-500/50 transition-all">
              <FaShippingFast className="text-5xl text-orange-500 mb-6 mx-auto" />
              <h3 className="text-xl font-bold text-white mb-3">Swift & Trackable</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Our AI-powered logistics deliver your orders quickly and securely with live tracking updates.</p>
            </div>
          </div>
        </section> */}

        {/* CTA */}
        {/* <section className="py-20 px-6">
          <div className="max-w-5xl mx-auto relative bg-gradient-to-r from-orange-500 to-orange-600 rounded-[3rem] p-12 text-center text-white shadow-2xl shadow-orange-500/20 overflow-hidden">
             <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl -mr-10 -mt-10"></div>
             <h2 data-aos="fade-down" className="text-4xl font-black mb-4 relative z-10">Ready to Explore?</h2>
             <p data-aos="fade-down" className="mb-8 text-white/80 font-medium relative z-10">Create your profile and start discovering new sellers near you.</p>
             <button data-aos="fade-up" onClick={() => navigate("/auth")} className="px-12 py-4 bg-white text-gray-900 font-black rounded-2xl hover:scale-105 transition-all shadow-xl relative z-10">
               Start Now
             </button>
          </div>
        </section> */}

        {/* Footer */}
        <footer className="bg-[#070A11] text-white py-16 border-t border-white/5">
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 grid-cols-3 gap-12 px-6">
            <div>
              <h3 className="font-black text-2xl text-orange-500 mb-6 uppercase tracking-tighter">OurASAP</h3>
              <ul className="space-y-3 text-gray-400 text-sm">
                <li onClick={() => navigate("/about")} className="hover:text-white cursor-pointer transition">About Us</li>
                <li onClick={() => navigate("/faq")} className="hover:text-white cursor-pointer transition">FAQ</li>
                <li onClick={() => navigate("/terms&condition")} className="hover:text-white cursor-pointer transition">Terms & Conditions</li>
                <li onClick={() => navigate("/privatepolicy")} className="hover:text-white cursor-pointer transition">Privacy Policy</li>
                
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-6">Services</h3>
              <ul className="space-y-3 text-gray-400 text-sm">
                <li onClick={() => navigate("/auth")} className="hover:text-white cursor-pointer">Start Chat</li>
                <li onClick={() => navigate("/feedback")} className="hover:text-white cursor-pointer">Feedback</li>
                <li onClick={() => navigate("/contactUs")} className="hover:text-white cursor-pointer">Report Issues</li>
                <li onClick={() => navigate("/perks")} className="hover:text-white cursor-pointer">Perks</li>
              </ul>
            </div>
            <div className="md:col-span-2 lg:col-span-1">
              <h3 className="font-bold text-lg mb-6 text-orange-500">Socials</h3>
              <div className="flex flex-wrap gap-4">
                 {Object.entries(socialLinks).map(([name, url]) => (
                    <a 
                      key={name} 
                      href={url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="px-4 py-2 bg-white/5 rounded-xl text-xs font-bold hover:bg-white/10 transition cursor-pointer border border-white/5"
                    >
                      {name}
                    </a>
                 ))}
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Home;